<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      title="定时催办归还雨伞"
      :modal-append-to-body="false"
      width="30%"
      style="margin-top: 180px"
    >
      <div class="container_dialog">
        <div class="container_item">
          <div class="label">规则:</div>
          <div class="value">
            借伞后超
            <el-input v-model="time"></el-input> 小时提醒
          </div>
        </div>
        <div class="container_item">
          <div class="label">状态:</div>
          <div class="value">
            <el-switch
              style="display: block"
              v-model="state"
              active-color="#4FA27D"
              :active-text="state ? '启用' : '禁用'"
            >
            </el-switch>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <template>
          <el-button @click="finished" class="no">取消</el-button>
          <el-button @click="submit" class="ok"> 提交 </el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import moment from "moment";
import apis from "@/apis/borrowingAnUmbrella";
import { getToken } from "@/utils/cookie";
export default {
  name: "dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "1",
    },
    rowList: {
      type: Object,
      default: ()=>{},
    },
  },
  data() {
    return {
      dialogVisible: false,
      time: "",
      state: true,
      object: {},
    };
  },
  watch: {
    visible(v) {
      this.dialogVisible = v;
      if(v){
        this.object = this.rowList
        this.time = this.object.hour
        this.state = this.object.state == 1 ? true : false
      }
    },
  },
  mounted() {},
  methods: {
    // 关闭弹窗
    beforeClose(done) {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      done();
    },
    // 刷新数据
    finished() {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      this.$emit("changeUpload");
    },
    // 提交数据
    submit() {
      const params = {
        id: this.object.id,
        hour: this.time,
        state: this.state ? 1 : 2,
        updateId: getToken(),
      }
      apis.buSetTiming(params).then(res=>{
        if(res.code == 200){
          this.$message({
            type: "success",
            message: "设置成功"
          })
          this.finished()
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.container_dialog {
  padding-left: 50px;
  .container_item {
    display: flex;
    align-items: center;
    font-size: 11px * $zoom;
    margin-bottom: 50px;
    color: #282b32;
    .value {
      margin-left: 20px;
      flex: 1;
      display: flex;
      align-items: center;
      ::v-deep {
        .el-input,
        .el-date-editor {
          width: 50px * $zoom;
          height: 30px * $zoom;
          background: #fafafa;
          border-radius: 20px;
          margin: 0 20px;
          .el-input__inner {
            width: 50px * $zoom;
            height: 30px * $zoom !important;
            background: #fafafa;
            // border: 1px solid #ccc;
            border-radius: 20px;
          }
          .el-range-separator {
            line-height: 33px * $zoom !important;
            padding: 0 40px 0 20px;
          }
        }
        .el-switch__core {
          width: 88px !important;
          height: 48px !important;
          border-radius: 50px;
        }
        .el-switch__label {
          color: #282b32;
        }
        .el-switch__label * {
          font-size: 32px !important;
        }
        .el-switch__core:after {
          width: 40px;
          height: 40px;
        }
        .el-switch.is-checked .el-switch__core::after {
          margin-left: -43px;
        }
      }
    }
  }
  .container_item:nth-child(1) {
    .value {
      color: #666666;
    }
  }
}
.dialog-footer {
  .ok {
    width: 75px * $zoom;
    height: 32px * $zoom;
    background: #4fa27d;
    border-radius: 20px;
    font-size: 11px * $zoom;
    color: #fff;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .no {
    width: 75px * $zoom;
    height: 32px * $zoom;
    background: none;
    border-radius: 20px;
    font-size: 11px * $zoom;
    color: #666;
    border: 1px solid #666;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
::v-deep {
  .el-dialog {
    margin-top: 0 !important;
    border-radius: 30px;
  }
  .el-dialog__header {
    padding: 0 !important;
    height: 150px;
    border-bottom: 1px solid #ccc;
    position: relative;
    .el-dialog__title {
      position: absolute;
      top: 35%;
      left: 50px;
    }
    .el-dialog__headerbtn {
      top: 35%;
      font-size: 40px;
    }
  }
  .el-dialog__body {
    // background: #f7f9fa;
    // height: 75vh;
    // overflow: auto;
    // &::-webkit-scrollbar {
    // display: none;
    // }
  }
}
</style>
